import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookinginpunne() {



const cardData = {
  keyword: "Cab Booking in Pune",
  heading: "Lotus Cab: Cab Booking in Pune",

  headingDescription:
    "Lotus Cab offers fast, reliable, and affordable cab booking in Pune for all your local and outstation travel needs. Whether you need a quick city ride, airport transfer, corporate cab, family trip vehicle, or long-distance taxi, we provide flexible booking options with transparent per kilometer pricing. Our fleet includes AC sedans, SUVs, Innova Crysta, Kia Carens, Swift Dzire, and even mini buses for group travel. All vehicles are well-maintained, sanitized, and driven by professional chauffeurs trained for safe and smooth journeys. From one-way drop services to round-trip and same-day return bookings, we ensure punctual pickup anywhere in Pune. With easy online booking and 24/7 customer support, Lotus Cab makes your travel planning simple, comfortable, and stress-free.",

  top: "Top Places to Visit in Pune with Lotus Cab",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most iconic historical landmarks representing the Maratha empire. Located in the heart of the city, it attracts tourists, students, and families throughout the year. Comfortable cab booking ensures smooth city travel without parking hassles. AC sedans are ideal for heritage sightseeing tours. Lotus Cab offers flexible waiting time for local exploration."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a peaceful heritage site linked to India’s freedom movement. The large gardens and museum make it a popular family and educational visit destination. Booking a cab ensures comfortable and timely travel."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a famous trekking and weekend destination near Pune. SUV cab booking is recommended for comfortable hill-road travel. Lotus Cab ensures safe highway driving and flexible return options."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "One of Pune’s most visited spiritual places, Dagdusheth Temple attracts devotees daily. Easy cab booking helps avoid city traffic stress."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam is a scenic picnic spot ideal for family outings. Round-trip cab booking makes weekend travel convenient."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a beautiful hill destination near Pune. Outstation cab booking ensures smooth and comfortable travel."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a popular expressway getaway. AC SUVs provide comfortable weekend trip travel."
    },
    {
      title: "Pune Airport",
      description:
        "Airport cab booking ensures punctual pickup and drop with luggage support and flight tracking assistance."
    }
  ],

  services: [
    {
      name: "Pune Cab Booking",
      description:
        "Lotus Cab provides reliable Pune cab booking services for city travel, airport transfers, corporate rides, and outstation trips. Flexible booking options are available for one-way, round-trip, and hourly rentals. Our AC sedans and SUVs ensure comfortable travel in all seasons. Professional chauffeurs provide safe and punctual service. Transparent pricing ensures no hidden charges."
    },
    {
      name: "Online Cab Booking in Pune",
      description:
        "Easy online cab booking in Pune with instant confirmation and secure payment options. Choose from sedan, SUV, Innova, or luxury vehicles. 24/7 customer support available for assistance."
    },
    {
      name: "Airport Transfer Cab Pune",
      description:
        "Reliable airport cab booking for pickup and drop with on-time arrival and luggage support. Ideal for domestic and international flights."
    },
    {
      name: "Outstation Cab Booking Pune",
      description:
        "Comfortable outstation cab booking for Mumbai, Nashik, Mahabaleshwar, Shirdi, Hyderabad, and more. AC vehicles and experienced highway drivers included."
    },
    {
      name: "Corporate Cab Booking Pune",
      description:
        "Professional corporate cab solutions for meetings, employee transportation, and business travel requirements."
    },
    {
      name: "Family Trip Cab Pune",
      description:
        "Spacious vehicles suitable for family tours and weekend trips with safe driving and luggage support."
    },
    {
      name: "Luxury Cab Booking Pune",
      description:
        "Premium luxury car booking for executive travel, weddings, and VIP transport needs."
    },
    {
      name: "Mini Bus Booking Pune",
      description:
        "Group travel mini bus booking service for weddings, corporate outings, and school trips."
    }
  ],

  tableData: [
    ["Pune Cab Booking", "Online Cab Booking in Pune"],
    ["Book Cab in Pune", "Affordable Cab Booking Pune"],
    ["AC Cab Booking Pune", "Sedan Cab Booking Pune"],
    ["SUV Cab Booking Pune", "Luxury Cab Booking Pune"],
    ["Family Trip Cab Pune", "Corporate Cab Booking Pune"],
    ["Airport Transfer Cab Pune", "One Way Cab Booking Pune"],
    ["Round Trip Cab Booking Pune", "Outstation Cab Booking Pune"],
    ["Weekend Trip Cab Pune", "Same Day Cab Booking Pune"],
    ["Mini Bus Booking Pune", "Innova Crysta Cab Booking Pune"],
    ["Swift Dzire Cab Booking Pune", "Kia Carens Cab Booking Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Wide Fleet Selection",
      WhyChoosedescription:
        "Choose from sedan, SUV, Innova Crysta, Kia Carens, mini bus, and luxury vehicles based on your travel requirement."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear fare structure with per km rate and no hidden charges."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription:
        "Experienced and background-verified chauffeurs ensure safe and smooth journeys."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way, round-trip, same-day return, and hourly rental options available."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "All vehicles are air-conditioned and regularly sanitized."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly",
      WhyChoosedescription:
        "Suitable for business travel, family tours, and group outings."
    },
    {
      WhyChooseheading: "Doorstep Pickup Across Pune",
      WhyChoosedescription:
        "Pickup available from homes, hotels, IT parks, and airport."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock booking assistance and trip coordination."
    }
  ]
};

const faqData = [
  { question: "How can I book a cab in Pune?", answer: "You can book online, call customer support, or request instant booking via WhatsApp." },
  { question: "Is airport cab booking available?", answer: "Yes, 24/7 airport transfer services are available." },
  { question: "Are luxury vehicles available?", answer: "Yes, premium luxury cab options are available." },
  { question: "Is outstation cab booking available?", answer: "Yes, outstation cab services are available for multiple cities." },
  { question: "Is fare calculated per km?", answer: "Yes, transparent per kilometer pricing is followed." },
  { question: "Are drivers experienced?", answer: "Yes, professional chauffeurs ensure safe travel." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate cab packages are available." },
  { question: "Are vehicles sanitized?", answer: "Yes, vehicles are cleaned and sanitized regularly." },
  { question: "Is same-day booking possible?", answer: "Yes, same-day cab booking is available." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock customer assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "Booked a cab in Pune for airport transfer. Very punctual service and smooth ride experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Family weekend trip booking was easy and affordable. Clean car and professional driver.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable corporate cab booking service with transparent pricing and excellent support.",
    rating: 5
  }
];






















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Booking in Pune",
  "image": "https://lotuscab.com/assets/images/cab-booking-pune.jpg", 
  "description": "Lotus Cab provides online cab booking in Pune for one-way trips, round trips, airport transfers, corporate travel, family trips, weekend getaways, and outstation travel. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, Innova Crysta, Swift Dzire, Kia Carens, and more. Affordable rates, professional chauffeurs, and easy online booking for safe and comfortable rides.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "299",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/cab-booking-in-pune"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Cab Booking in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book cabs online in Pune with Lotus Cab. One-way, round-trip, airport transfers, family & corporate trips. AC, sedan, SUV, luxury cabs, Mini Bus, Innova Crysta, Swift Dzire, Kia Carens. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune Cab Booking, Online Cab Booking in Pune, Book Cab in Pune, Affordable Cab Booking Pune, AC Cab Booking Pune, Sedan Cab Booking Pune, SUV Cab Booking Pune, Luxury Cab Booking Pune, Family Trip Cab Pune, Corporate Cab Booking Pune, Airport Transfer Cab Pune, One Way Cab Booking Pune, Round Trip Cab Booking Pune, Outstation Cab Booking Pune, Weekend Trip Cab Pune, Same Day Cab Booking Pune, Mini Bus Booking Pune, Innova Crysta Cab Booking Pune, Swift Dzire Cab Booking Pune, Kia Carens Cab Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabbookinginpunne;